import { render, staticRenderFns } from "./TriotecaWidget.vue?vue&type=template&id=4b6d3824&"
import script from "./TriotecaWidget.vue?vue&type=script&lang=js&"
export * from "./TriotecaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports